import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
//import api_base_url from "../../";
import axiosInstance from "../../../../api/axiosInstance";

export const fetchJobTemplates = createAsyncThunk(
  "match/fetchJobTemplates",
  async ({ jobTypeId }) => {
    // if (!token) {
    //   throw new Error("Missing user token");
    // }

    const headers = new Headers();
   // headers.set("Authorization", `Bearer ${token}`);
    headers.append("Content-Type", "application/json");

    const response = await axiosInstance.get(
      `api/Jobs/GetFileTemplates?JobTypeId=${jobTypeId}`,
      {  headers: {
       // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }, }
    );

    return response.data;
  }
);

export const fetchTemplateFields = createAsyncThunk(
  "match/fetchTemplateFields",
  async ({ templateId }) => {
    // if (!token) {
    //   throw new Error("Missing user token");
    // }

    const response = await axiosInstance.get(
      `api/Jobs/GetTemplateFields?TemplateId=${templateId}`,
      {
        headers: {
         // Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  }
);

const initialState = {
  templates: [],
  selectedTemplateType: {},
  templateFields: [],
  columnHeaders: [],
  headerMapping: [],
  templateRetrievalStatus: "idle",
  templateRetrievalError: null,
  templateFieldsStatus: "idle",
  templateFieldsError: null,
};

const matchSlice = createSlice({
  name: "match",
  initialState,
  reducers: {
    setSelectedTemplateType(state, action) {
      state.selectedTemplateType = action.payload;
    },
    setColumnHeaders(state, action) {
      state.columnHeaders = action.payload;
    },
    setHeaderMapping(state, action) {
      state.headerMapping = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobTemplates.pending, (state) => {
        state.templateRetrievalStatus = "loading";
        state.templateRetrievalError = null;
      })
      .addCase(fetchJobTemplates.fulfilled, (state, action) => {
        state.templateRetrievalStatus = "succeeded";
        state.templates = action.payload;
      })
      .addCase(fetchJobTemplates.rejected, (state, action) => {
        state.templateRetrievalStatus = "failed";
        state.templateRetrievalError = action.error.message;
        state.templates = [];
      })
      .addCase(fetchTemplateFields.pending, (state) => {
        state.templateFieldsStatus = "loading";
        state.templateFieldsError = null;
      })
      .addCase(fetchTemplateFields.fulfilled, (state, action) => {
        state.templateFieldsStatus = "succeeded";
        state.templateFields = action.payload;
      })
      .addCase(fetchTemplateFields.rejected, (state, action) => {
        state.templateFieldsStatus = "failed";
        state.templateFieldsError = action.error.message;
        state.templateFields = [];
      });
  },
});

export const { setSelectedTemplateType, setColumnHeaders, setHeaderMapping } = matchSlice.actions;

export default matchSlice.reducer;
